export default function Footer (){
  return (
    <div id="footer">
      <div>
        <p>상호명 : {process.env.REACT_APP_CLINIC_NAME}</p>
        <p>Copyright 2025 {process.env.REACT_APP_CLINIC_NAME}. All Right Reserved.</p>
      </div>
    </div>
  )
}